import { Injectable } from '@angular/core';
import { CardBackgroundViewModel } from '../../card-background-view-model';
import { Observable } from 'rxjs';
import { KoanCardData } from '../../../../../../../models/print-cards/koan-card-data';

@Injectable()
export class KoanBusinessCardStackBackgroundViewModel extends CardBackgroundViewModel {
  public readonly cardData$: Observable<KoanCardData>;
}
